module.exports = __webpack_public_path__ + "static/media/v1.d950778e.png";